module.exports = __webpack_public_path__ + "img/Angle-double-right.5590cf20.svg";